import React, { useState, useEffect, useCallback } from 'react';
import { Table, Space, Select, Input, Button, message } from 'antd';
import { ReloadOutlined, SearchOutlined, FileAddOutlined } from '@ant-design/icons';
import { useFinanceApi, DOVIZ_OPTIONS } from '../api/financeApi';
import CreateRequestModal from '../shared/CreateRequestModal';
import { fmtAmount, fmtDate } from '../shared/format';
import { enhanceColumns, toplamGenislik } from '../../ortak/tableHelpers';

export default function CeklerTab({ lookups, perms }) {
  const api = useFinanceApi();
  const p = perms.cekler || {};
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [doviz, setDoviz] = useState(null);
  const [search, setSearch] = useState('');
  const [reqRow, setReqRow] = useState(null);

  const load = useCallback(async () => {
    if (p.view === false) return;
    setLoading(true);
    try {
      const params = {};
      if (doviz) params.doviz = doviz;
      if (search) params.genel_arama = search;
      setData(await api.get('/checks', params));
    } catch (e) {
      message.error(e?.response?.data?.detail || 'Çekler yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, [doviz, search]);

  useEffect(() => { load(); }, [load]);

  if (p.view === false) return <div style={{ padding: 24 }}>Görüntüleme yetkiniz yok.</div>;

  const columns = [
    { title: 'Firma', dataIndex: 'firma_adi', ellipsis: true },
    { title: 'Banka', dataIndex: 'banka_adi', ellipsis: true },
    { title: 'Çek No', dataIndex: 'cek_no' },
    { title: 'Şube', dataIndex: 'sube' },
    { title: 'Tutar', dataIndex: 'tutar', render: (v, r) => fmtAmount(v, r.doviz) },
    { title: 'Vade', dataIndex: 'vade', render: fmtDate },
    { title: 'Verilen Firma', dataIndex: 'verilen_firma', ellipsis: true },
    {
      title: 'İşlem', key: 'a', fixed: 'right', width: 110,
      render: (_, r) => (
        <Button size="small" icon={<FileAddOutlined />} onClick={() => setReqRow(r)}>Talep</Button>
      ),
    },
  ];

  return (
    <div>
      <Space wrap style={{ marginBottom: 12 }}>
        <Select allowClear placeholder="Döviz" style={{ width: 110 }} value={doviz}
          onChange={setDoviz} options={DOVIZ_OPTIONS} />
        <Input allowClear prefix={<SearchOutlined />} placeholder="Ara..." style={{ width: 220 }}
          value={search} onChange={(e) => setSearch(e.target.value)} onPressEnter={load} />
        <Button icon={<ReloadOutlined />} onClick={load}>Yenile</Button>
        <span style={{ color: '#888' }}>{data.length} kayıt</span>
      </Space>
      <Table rowKey="id" size="small" loading={loading} dataSource={data} columns={enhanceColumns(columns)}
        scroll={{ x: toplamGenislik(enhanceColumns(columns)), y: 480 }} pagination={{ pageSize: 50 }} />
      <CreateRequestModal row={reqRow} kind="checks" lookups={lookups}
        onClose={() => setReqRow(null)} onDone={() => setReqRow(null)} />
    </div>
  );
}
